export default __webpack_public_path__ + "static/media/ourclient2.a9e3300c.png";